import { store } from "Root";
import { callInitTimeTableAlertPopup } from "pages/init/InitTimeTable.js";
import AsyncStorage from "@react-native-community/async-storage";
import qs from "qs";
import axios from "axios";
import AlertConfirmPopup from "components/common/AlertConfirmPopup";

import { logout } from "store/modules/common/loginReducer";

export function checkMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|wj_flutter/i.test(navigator.userAgent);
}

export function checkIsMobileApp() {
    if (window.android || window.flutter_webview) {
        return true;
    }
    return false;
}

export function checkAgent() {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
    if (varUA.indexOf("android") > -1) {
        return "android";
    } else if (varUA.indexOf("iphone") > -1 || varUA.indexOf("ipad") > -1 || varUA.indexOf("ipod") > -1) {
        return "ios";
    } else if (varUA.indexOf("wj_flutter") > -1) {
        return "wj_flutter";
    } else {
        //아이폰, 안드로이드 외
        return "other";
    }
}
// Description : Get Pad Push Token
// Author : 10012120
function getPushToken() {
    console.log("getPushToken");
    try {
        if (window.android) {
            window.android.getPushToken();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "getPushToken" }));
        }
    } catch (error) {
        console.log(error);
    }
}
// Description : Result Pad Push Token
// Author : 10012120
// TODO: 안 쓰는 듯 (19002021)
export function resultPushToken(pushToken) {
    const headerParam = {
        user_id: "2",
    };

    let queryParam = {
        STD_DT: "1",
        MMBR_SEQ: "2",
    };
    const param = {
        REQUEST_API: "3",
        HTTP_METHOD: "4",
    };
    //callPost(headerParam, param, queryParam);

    if (checkMobile()) {
        try {
            alert(pushToken);
        } catch (error) {
            console.log(error);
        }
    }
}

// TODO: 왜 여기있지
export function getStore(storeNm, reducerNm, chKey, chValue, callback) {
    return AsyncStorage.getAllKeys((err, keys) => {
        return AsyncStorage.multiGet(keys, (error, stores) => {
            let persistStore = stores.filter((value) => value[0].match(storeNm));
            if (persistStore.length > 0) {
                let persistKey = persistStore[0][0];
                let persistValue = JSON.parse(persistStore[0][1]);

                let parsedStore = JSON.parse(persistValue[reducerNm]);
                parsedStore[chKey] = chValue;

                persistValue[reducerNm] = JSON.stringify(parsedStore);
                persistStore = JSON.stringify(persistValue);

                AsyncStorage.setItem(persistKey, persistStore);

                callback(true);
            }
        });
    });
}

// TODO: 왜 여기있는지 확인
export const settingColorTheme = (color) => {
    // javascript:callBridgeJs.settingColorTheme(dark);
    let chColor = false;

    if (color === "dark") chColor = false;
    else chColor = true;

    getStore("persist", "settingReducer", "mode", chColor, (resData) => {
        //alert("settingColorTheme - color");
        // if (resData) {
        //     window.location.reload();
        // }
    });
};

export function launchStudyPlayer(param) {
    try {
        if (window.android) {
            window.android.launchStudyPlayer(JSON.stringify(param));
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "launchStudyPlayer" }));
        } else {
            if (param.PLAYER_URL) {
                window.location.href = param.PLAYER_URL;
            } else {
                window.location.href = "/playerMain?" + qs.stringify(param);
            }
        }
    } catch (error) {
        console.error(error);
    }
}

export function exitStudyPlayer() {
    console.log("exitStudyPlayer");
    try {
        if (window.android) {
            window.android.exitStudyPlayer();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "exitStudyPlayer" }));
            callClearAllWebViewCaches(); // 웹뷰 캐시 삭제
        }
    } catch (error) {
        console.log(error);
    }
}

export function exitNativeStudyPlayerPopup() {
    console.log("exitNativeStudyPlayerPopup");
    try {
        if (window.android) {
            window.android.exitNativeStudyPlayerPopup();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: null, handlerName: "exitNativeStudyPlayerPopup" }),
            );
        }
    } catch (error) {
        console.log(error);
    }
}

export function sendVodPlayTime(value) {
    console.log("sendVodPlayTime");
    try {
        if (window.android) {
            window.android.sendVodPlayTime(value);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: value, handlerName: "sendVodPlayTime" }));
        }
    } catch (error) {
        console.log(error);
    }
}

export function callUpdatePlayerCornerStatus(param) {
    try {
        if (param) {
            if (window.android) {
                window.android.callUpdatePlayerCornerStatus(JSON.stringify(param));
            } else if (window.flutter_webview) {
                window.flutter_webview.postMessage(
                    JSON.stringify({ params: param, handlerName: "callUpdatePlayerCornerStatus" }),
                );
            }
            console.log("callUpdatePlayerCornerStatus" + param);
        }
    } catch (error) {
        console.log(error);
    }
}

// 학습플레이어 완료시 화살표 뜨게 하는 함수
export function callCornerComplete() {
    console.log("call coner complete");
    try {
        if (window.android) {
            window.android.callCornerComplete();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "callCornerComplete" }));
        }
    } catch (error) {
        console.error(error);
    }
}

export function launchOnlineLibraryPlayer() {
    console.log("launchOnlineLibraryPlayer");
    try {
        if (window.android) {
            window.android.launchOnlineLibraryPlayer();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: null, handlerName: "launchOnlineLibraryPlayer" }),
            );
        }
    } catch (error) {
        console.log(error);
    }
}

//학습플레이어 내 Q&A 다이얼로그 호출 브릿지
export function showPlayerQnADialog() {
    try {
        if (window.android) {
            window.android.showQnADialog();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "showQnADialog" }));
        }
    } catch (error) {
        console.log(error);
    }
}

export function callNativeAlert(param) {
    try {
        if (window.android) {
            window.android.callNativeAlert(JSON.stringify(param));
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "callNativeAlert" }));
        } else {
            alert(param.MSG);
        }
    } catch (error) {
        alert(param.MSG);
    }
}

export function callNativeConfirm(confirmParam) {
    console.log("callNativeConfirm");
    try {
        if (window.android) {
            window.android.callNativeConfirm(JSON.stringify(confirmParam));
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: confirmParam, handlerName: "callNativeConfirm" }),
            );
        } else {
            window.confirm(confirmParam.MSG);
        }
    } catch (error) {
        if (window.confirm(confirmParam.MSG)) {
            window[confirmParam.CALLBACK]("true");
        }
    }
}

export const settingViewType = (param) => {
    const param_1_1 = {
        VIEW_TYPE: "GNB",
        DRWR_VIEW: "Y",
    };

    const param_1_2 = {
        VIEW_TYPE: "GNB",
        DRWR_VIEW: "N",
    };

    const param_2_1 = {
        VIEW_TYPE: "POP",
        DRWR_VIEW: "Y",
    };

    const param_2_2 = {
        VIEW_TYPE: "POP",
        DRWR_VIEW: "N",
    };

    try {
        if (window.android) {
            window.android.settingViewType(JSON.stringify(param));
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "settingViewType" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const callNativeHistoryBack = () => {
    try {
        if (window.android) {
            window.android.callNativeHistoryBack();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "callNativeHistoryBack" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const launchWebView = (param, history) => {
    // POP_T 인 경우 배경 투명 처리를 위한 파라미터 추가
    console.log(param);
    if (param.PGM_SCRN_TY === "POP_T") {
        if (param.PGM_URL.indexOf("?") === -1) {
            param.PGM_URL += "?PAGE_TYPE=T";
        } else {
            param.PGM_URL += "&PAGE_TYPE=T";
        }
    }

    //SAMPLE
    // const param={
    //     PGM_URL : "/lounge/inqRpl/inqWrite",
    //     PGM_SCRN_TY : "POP_F", POP_T
    //     PGM_NAME : "질문하기"
    // }

    try {
        if (window.android) {
            window.android.launchWebView(JSON.stringify(param));
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "launchWebView" }));
        }
    } catch (error) {
        console.log(error);
    }
};

// 전체 웹뷰로 외부 URL 열기 (launchWebView와 다른 브릿지 사용)
//   - 앱 웹뷰: openFullWebView 브릿지로 전체 웹뷰에서 오픈
//   - 데스크톱 웹: 현재 창에서 URL 이동
export const openFullWebView = (url) => {
    if (!checkIsMobileApp()) {
        window.location.href = url;
        return;
    }

    try {
        if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: { URL: url }, handlerName: "openFullWebView" }));
        }
    } catch (error) {
        console.log(error);
    }
};

// channel: flutter_webview,
// message: {"params":{"PGM_URL":"https://app.pagecall.net/63805b230e5eac27aa5cac811","PGM_SCRN_TY":"POP_F","PGM_NAME":""},"handlerName":"launchWebView"}
// export function launchAllTabView(param) {

//     if (param.PGM_SCRN_TY === 'POP_F') {
//         if (param.PGM_URL.indexOf('?') === -1) {
//             param.PGM_URL += '?PAGE_TYPE=T';
//         } else {
//             param.PGM_URL += '&PAGE_TYPE=T';
//         }
//     }

//     try {
//         if (window.flutter_webview) {
//             window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "launchAllTabView" }));
//         } else {
//             if (param.entryUrl) {
//                 window.location.href = param.entryUrl;
//             } else {
//                 window.location.href = "/" + qs.stringify(param);
//             }
//         }
//     } catch (error) {
//         console.error(error);
//     }
// }

// 웹뷰 종료
export const closeWebView = (param, history) => {
    console.log("window.callBridge.closeWebView");

    const state = store.getState();

    // 시간표 설정 페이지가 아닌 경우 웹뷰 닫기
    if (!state.initTimeTableReducer.isInitTimeTableOpen) {
        try {
            if (window.android) {
                if (param) {
                    window.android.closeWebView(param);
                } else {
                    window.android.closeWebView();
                }
            } else if (window.flutter_webview) {
                if (param) {
                    window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "closeWebView" }));
                } else {
                    window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "closeWebView" }));
                }
            } else {
                history.go(-1);
            }
        } catch (error) {
            window.history.back();
        }
    }
    // 시간표 설정 페이지인 경우 알람 팝업 호출
    else {
        const mmbrSeq = state.loginReducer.mmbrSeq;
        const gradCd = state.loginReducer.gradCd;
        const userId = state.loginReducer.userId;

        callInitTimeTableAlertPopup(mmbrSeq, gradCd, userId);
    }
};

// 웹뷰 종료 후 별도 리다이렉션이 필요한경우
export const closeWebViewAndRedirectUrl = (param, history = null) => {
    console.log("window.callBridge.closeWebViewAndRedirectUrl");
    //SAMPLE
    // const param={
    //     PGM_URL : "/lounge/inqRpl/inqWrite",
    // }
    try {
        if (window.android) {
            window.android.closeWebViewAndRedirectUrl(JSON.stringify(param));
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: param, handlerName: "closeWebViewAndRedirectUrl" }),
            );
        } else {
            history.push(param.PGM_URL);
        }
    } catch (error) {
        console.error(error);

        if (history) {
            history.push(param.PGM_URL);
        } else {
            window.history.pushState({}, "", param.PGM_URL);
        }
        //history.push(param.PGM_URL);
    }
};

export const callNativeLoading = (param) => {
    console.log("callNativeLoading");
    try {
        if (window.android) {
            window.android.callNativeLoading(param);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "callNativeLoading" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const sendQstCd = (param) => {
    try {
        if (window.android) {
            window.android.sendQstCd(param);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "sendQstCd" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const sendMmbrNotiCnfrYn = (param) => {
    console.log("sendMmbrNotiCnfrYn exception");
    // const param={
    //     CNFR_YN : "Y",
    // }
    try {
        if (window.android) {
            window.android.sendMmbrNotiCnfrYn(param);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "sendMmbrNotiCnfrYn" }));
        }
    } catch (error) {
        console.error(error);
    }
};

export const closeStudyPlayer = () => {
    try {
        window.location.reload();
    } catch (error) {
        console.error(error);
    }
};

export const callReloadWebView = (url) => {
    try {
        window.location.replace(url);
    } catch (error) {
        console.error(error);
    }
};

export const closeApp = () => {
    try {
        if (window.android) {
            window.android.exitApp();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "exitApp" }));
        }
    } catch (error) {
        console.log(error);
    }
};

const doDesktopLogout = (history) => {
    axios
        .get("/common/logout")
        .then((response) => {
            callbackLogout(response, history);
        })
        .catch((error) => {
            console.error(error);
        });
};

const callbackLogout = (_, history) => {
    resetAllSavedAuthInfo();
    promiseLogout().then(() => {
        if (history) {
            history.push("/");
            return;
        }
        window.location.href = "/";
    });
};

const promiseLogout = () => {
    return Promise.resolve(store.dispatch(logout()));
};

const resetAllSavedAuthInfo = () => {
    localStorage.removeItem("persist:root");
    localStorage.removeItem("lastPedcCheckDate");
    document.cookie = "cookiename=MID_SESSION_ID; expires = Thu, 01 Jan 1970 00:00:00 GMT";
};

const duplicateLoginAlert = (errorMsg) => {
    const reqData = {
        type: "ALERT",
        msg: errorMsg,
    };

    AlertConfirmPopup(reqData);
};

export const callLogout = (errorMsg, code, history) => {
    try {
        if (window.android) {
            window.android.callLogout(errorMsg);
            return;
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: errorMsg, handlerName: "logout" }));
            return;
        } else if (code) {
            duplicateLoginAlert(errorMsg);
        }

        doDesktopLogout(history);
    } catch (error) {
        console.log(error);
    }
};

export const callServiceOut = () => {
    try {
        localStorage.removeItem("persist:root");
        localStorage.removeItem("lastPedcCheckDate");
    } catch (error) {
        console.log("callServiceOut exception");
    }
};

export const hideKeyboard = () => {
    try {
        if (window.android) {
            window.android.hideKeyboard();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "hideKeyboard" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const showStudyCompleteToast = (param) => {
    try {
        if (window.android) {
            window.android.showStudyCompleteToast(param);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: param, handlerName: "showStudyCompleteToast" }),
            );
        }
    } catch (error) {
        console.log(error);
    }
};

export const callChatBack = (url) => {
    try {
        let entPathYn = false;

        // url 쪼개기
        let search = url.substring(url.indexOf("?"));

        if (search.indexOf("entPath") > -1 && search.indexOf("modYn") > -1) {
            let param = {};

            let params = search.split("&");

            let pgmScrnTy = "";
            let pgmUrl = "";
            for (let i = 0; i < params.length; i++) {
                if (params[i].indexOf("pgmScrnTy") > -1) {
                    pgmScrnTy = params[i].substring(params[i].indexOf("=") + 1);
                }

                // 이동 해야할 경로
                if (params[i].indexOf("entPath") > -1) {
                    pgmUrl = params[i].substring(params[i].indexOf("=") + 1);
                    entPathYn = true;
                }
            }

            if (entPathYn) {
                param = {
                    PGM_SCRN_TY: pgmScrnTy || "POP",
                    PGM_URL: pgmUrl,
                };

                if (window.android) {
                    window.android.closeWebViewAndRedirectUrl(JSON.stringify(param));
                } else if (window.flutter_webview) {
                    window.flutter_webview.postMessage(
                        JSON.stringify({ params: param, handlerName: "closeWebViewAndRedirectUrl" }),
                    );
                }
            } else {
                closeWebView();
            }
        } else {
            closeWebView();
        }
    } catch (error) {
        console.log("errorMsg", error);
        console.log("url", url);
        closeWebView();
    }
};

export const checkPm = (msg) => {
    console.log("checkPm 브릿지 호출");
    try {
        if (window.android) {
            window.android.checkPm(msg);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: msg, handlerName: "checkPm" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const callLnbView = (value) => {
    try {
        if (window.android) {
            window.android.callLnbView(value);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: value, handlerName: "callLnbView" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const callGuidView = (value) => {
    try {
        if (window.android) {
            window.android.callGuidView(value);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: value, handlerName: "callGuidView" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const callNativeBackButton = () => {
    const state = store.getState();

    // 시간표 설정 팝업이 열려있지 않은 경우 네이티브의 뒤로가기 실행
    if (!state.initTimeTableReducer.isInitTimeTablePopupOpen) {
        try {
            if (window.android) {
                window.android.callNativeBackButton();
            } else if (window.flutter_webview) {
                window.flutter_webview.postMessage(
                    JSON.stringify({ params: null, handlerName: "callNativeBackButton" }),
                );
            }
        } catch (error) {
            console.log(error);
        }
    }
};

// 안드로이드의 네이티브 버튼 동작시
//    -> 네이티브 단에서 스케줄 페이지인지 아닌지 묻지 않도록 변경
export const callExistBasicSchedule = () => {
    try {
        if (window.android) {
            window.android.existBasicSchedule();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "existBasicSchedule" }));
        }
    } catch (error) {
        console.log(error);
    }
};

// 메인 페이지 로딩이 완료 되었을 때 -> 테마를 변경 버튼을 enable상태로 변경한다.
export const callChangeThemeBtnStatus = () => {
    try {
        if (window.android) {
            window.android.changeThemeBtnStatus();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "changeThemeBtnStatus" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const launchStudyNote = () => {
    try {
        if (window.android) {
            window.android.launchStudyNote();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "launchStudyNote" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const showQuestionErrorReport = () => {
    try {
        if (window.android) {
            window.android.showQuestionErrorReport();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: null, handlerName: "showQuestionErrorReport" }),
            );
        }
    } catch (error) {
        console.log(error);
    }
};

// 플랫폼 정보 가져오기
export const getPlatform = () => {
    try {
        if (window.android) {
            window.android.getPlatform();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "getPlatform" }));
        }
    } catch (error) {
        window.setPlatform("Default");
    }
};

export const callVideoDuration = (duration) => {
    try {
        if (window.android) {
            window.android.callVideoDuration(duration);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: duration, handlerName: "callVideoDuration" }));
        }
    } catch (error) {
        console.error(error);
    }
};

export const settingDeviceSound = (value) => {
    try {
        if (window.android) {
            window.android.settingDeviceSound(value);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: value, handlerName: "settingDeviceSound" }));
        }
    } catch (error) {
        console.error(error);
    }
};

export const settingDeviceBright = (value) => {
    try {
        if (window.android) {
            window.android.settingDeviceBright(value);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: value, handlerName: "settingDeviceBright" }));
        }
    } catch (error) {
        console.error(error);
    }
};

export const onClickGetSoundBtn = () => {
    try {
        if (window.android) {
            window.android.callDeviceSound();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "callDeviceSound" }));
        }
    } catch (error) {
        console.error(error);
    }
};

export const callDeviceBright = () => {
    try {
        if (window.android) {
            window.android.callDeviceBright();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "callDeviceBright" }));
        }
    } catch (error) {
        console.error(error);
    }
};

export const callMovePlayerNextCorner = () => {
    try {
        if (window.android) {
            window.android.callMovePlayerNextCorner();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: null, handlerName: "callMovePlayerNextCorner" }),
            );
        }
    } catch (error) {
        console.error(error);
    }
};

export const readyForStudy = () => {
    try {
        if (window.android) {
            window.android.readyForStudy();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "readyForStudy" }));
        }
    } catch (error) {
        console.log(error);
    }
};

export const launchPDFViewer = (url, history) => {
    try {
        if (window.android) {
            window.android.launchPDFViewer(url);
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: url, handlerName: "launchPDFViewer" }));
        } else {
            history.push(url);
        }
    } catch (error) {
        console.error(error);
    }
};

// 학습플레이어의 비정상적인 소리 재생을 방지하기 위한, 학습플레이어 관련 브릿지들
// 학플 액티비티가 맨 위에 있는지
export const isStudyActivityRunning = () => {
    try {
        if (window.android) {
            window.android.isStudyActivityRunning();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "isStudyActivityRunning" }));
        }
    } catch (error) {
        console.log(JSON.stringify(error));
        console.error(error);
    }
};
// 앱이 포어그라운드 상태인지
export const isAppForeground = () => {
    try {
        if (window.android) {
            window.android.isAppForeground();
        } else if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: null, handlerName: "isAppForeground" }));
        }
    } catch (error) {
        console.log(JSON.stringify(error));
        console.error(error);
    }
};

// 인증 관련: 앱에 인증 정보 전달하기
export const loginInfo = (loginInfo) => {
    try {
        if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: JSON.stringify(loginInfo), handlerName: "loginInfo" }),
            );
        }
    } catch (error) {
        console.log(JSON.stringify(error));
        console.error(error);
    }
};

export const callChangeTheme = (themeName) => {
    try {
        if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: themeName, handlerName: "changeTheme" }));
        }
    } catch (error) {
        console.error(error);
    }
};

// PDF File 정보 전달하기(마이페이지 > 나의자료실)
export const callPDFFileInfo = (param) => {
    try {
        if (String(process.env.REACT_APP_ENV).trim() === "dev")
            console.log("callPDFFileInfo :", JSON.stringify({ params: param, handlerName: "callPDFFileInfo" }));

        if (window.flutter_webview) {
            window.flutter_webview.postMessage(JSON.stringify({ params: param, handlerName: "callPDFFileInfo" }));
        }
    } catch (error) {
        console.log(JSON.stringify(error));
        console.error(error);
    }
};

// 웹뷰 캐시 삭제하기
export const callClearAllWebViewCaches = () => {
    try {
        if (String(process.env.REACT_APP_ENV).trim() === "dev")
            console.log(
                "callClearAllWebViewCaches :",
                JSON.stringify({ params: null, handlerName: "callClearAllWebViewCaches" }),
            );

        if (window.flutter_webview) {
            window.flutter_webview.postMessage(
                JSON.stringify({ params: null, handlerName: "callClearAllWebViewCaches" }),
            );
        }
    } catch (error) {
        console.log(JSON.stringify(error));
        console.error(error);
    }
};
